import { IS_PRODUCTION } from './env';

export const LSTORAGE_KEY = {
    CONTENTS_LIKE: 'CONTENTS_LIKE',
    TTS_VOICE: 'TTS_VOICE',
    LATEST_READ: 'LATEST_READ',
    SELECT_REGION: 'select.region',
    TOGGLE_NEXT: 'TOGGLE_NEXT',

    VIEW_DETAIL: 'VIEW_DETAIL',
    //redux
    REDUX_CONTENT: 'redux.content',

    // event
    SIG_INSTALL_APP: 'sig.install.app',
    INSTALL_APP: 'install.',

    BM_UID: 'bm_uid',
};

export const SESSION_KEY = {
    ZSID: 'za_bm_sid',
    CLOSE_SLIDER_FOOTER: 'close.download',
    SSID: 'ssid',
    BM_IN_MINIAPP: 'bm_in_miniapp',
};

export const COOKIE_KEY = {
    BM_GY: '_bm_gy',
    BM_USER: '_bm_user',
    BM_SEGMENTS: '_bm_segments',
    BM_FORCE_IS_MB: '_bm_force_is_mb',
    BM_CONTENT_READ: IS_PRODUCTION
        ? '_live3_bm_contents_read'
        : '_dev2_bm_contents_read',
    BM_TIME_CONTENT_READ: IS_PRODUCTION
        ? '_live3_bm_times_content_read'
        : '_dev2_bm_times_content_read',
    BM_CLICK_LOGIN: '_bm_click_login',
    BM_UID: 'uid',
    ZA_ID: '__zi',
};
